import { E212 as PREFIX, DEFAULT_PER_PAGE_MEDIUM } from "const";
import {
    E212_SET_LOADING,
    E212_SET_LIST,
    E212_OPERATOR_SET_LIST,
    E212_OPERATOR_DROPDOWN_SET_LOADING,
    E212_OPERATOR_DROPDOWN_SET_LIST,
    E212_COUNTRY_DROPDOWN_SET_LIST,
    E212_COUNTRY_DROPDOWN_SET_LOADING
} from "actions/actionTypes";

const initialState = {
    list: [],
    operator_dropdown_list: [],
    operator_dropdown_loading: false,
    country_dropdown_list: [],
    country_dropdown_loading: false,
    operator_list: [],
    loading: true,
    page: 1,
    count: 0,
    per_page: DEFAULT_PER_PAGE_MEDIUM
};

const handlers = {
    [E212_SET_LOADING]: (state, { payload }) => ({ ...state, loading: payload }),
    [E212_SET_LIST]: (state, { payload: { list, page, perPage, count } }) => {
        // const modifiedList = list.map((item) => {
        //     return {
        //         ...item,
        //         mcc_mnc: `${item.mcc}${item.mnc}`
        //     }
        // });
        return {
            ...state,
            list: list,
            page,
            per_page: perPage,
            count,
            loading: false,
        }
    },
    [E212_OPERATOR_SET_LIST]: (state, { payload: { operator_list } }) => ({
        ...state,
        operator_list
    }),
    [E212_OPERATOR_DROPDOWN_SET_LOADING]: (state, { payload }) => ({ ...state, operator_dropdown_loading: payload }),
    [E212_OPERATOR_DROPDOWN_SET_LIST]: (state, { payload: { operator_dropdown_list } }) => ({
        ...state,
        operator_dropdown_list: operator_dropdown_list
    }),
    [E212_COUNTRY_DROPDOWN_SET_LOADING]: (state, { payload }) => ({ ...state, country_dropdown_loading: payload }),
    [E212_COUNTRY_DROPDOWN_SET_LIST]: (state, { payload: { country_dropdown_list } }) => ({
        ...state,
        country_dropdown_list: country_dropdown_list
    }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
}